import { createSlice } from '@reduxjs/toolkit'

export const simulateMgtSlice = createSlice({
    name: 'simulateMgt',
    initialState: {
        simulatorProfiles: [], // simulatorProfilesSlice
        selectedProfileSimulate: undefined, // selectedProfileSimulateSlice
        selectedProfilesPolicySimulator: [], // selectedProfilesPolicySimulatorSlice
        usedParametersInDiagram: [], // usedParametersInDiagramSlice
        statementOptions: [], // statementOptionsSlice
        selectedStatement: null, // selectedStatementSlice
        statementHighlightPaths: [] // statementHighlightPathsSlice
    },
    reducers: {
        setSimulatorProfiles: (state, action) => {
            state.simulatorProfiles = action.payload;
        },
        setSelectedProfileSimulate: (state, action) => {
            state.selectedProfileSimulate = action.payload;
        },
        setSelectedProfilesPolicySimulator: (state, action) => {
            state.selectedProfilesPolicySimulator = action.payload;
        },
        setUsedParametersInDiagram: (state, action) => {
            state.usedParametersInDiagram = action.payload;
        },
        setStatementOptions: (state, action) => {
            state.statementOptions = action.payload;
        },
        setSelectedStatement: (state, action) => {
            state.selectedStatement = action.payload;
        },
        setStatementHighlightPaths: (state, action) => {
            state.statementHighlightPaths = action.payload;
        }
    },
})

export const {
    setSimulatorProfiles,
    setSelectedProfileSimulate,
    setSelectedProfilesPolicySimulator,
    setUsedParametersInDiagram,
    setStatementOptions,
    setSelectedStatement,
    setStatementHighlightPaths
} = simulateMgtSlice.actions;

export const getSimulatorProfiles = (state) => state.simulateMgt.simulatorProfiles;
export const getSelectedProfileSimulate = (state) => state.simulateMgt.selectedProfileSimulate;
export const getSelectedProfilesPolicySimulator = (state) => state.simulateMgt.selectedProfilesPolicySimulator;
export const getUsedParametersInDiagram = (state) => state.simulateMgt.usedParametersInDiagram;
export const getStatementOptions = (state) => state.simulateMgt.statementOptions;
export const getSelectedStatement = (state) => state.simulateMgt.selectedStatement;
export const getStatementHighlightPaths = (state) => state.simulateMgt.statementHighlightPaths;

export default simulateMgtSlice.reducer